import SignalContent from "../signal_content";
import { newSettingDataSetType, newlampColorAndFlagMapType, SignallampStoreType, MstSignallampComponentType } from "../../../types/types";

export function makeSendSignallampComponentSettingData(self: SignalContent) {

  if (self.deviceIds.length !== 0 && self.selectDeviceId === "") {
    self.selectDeviceId = self.deviceIds[0];
  }

  const updateData: MstSignallampComponentType = {
    user_id: self.userID,
    signallamp_id: self.signallampID,
    device_ids: self.deviceIds,
    select_device_id: self.selectDeviceId,
    component_title: self.componentTitle,
    use_alert_sound: self.useAlertSound,
  };

  return updateData;
}

function makeFlagsSettingParams(useAlertSound: boolean, newMailsList: string[], Alertflag: boolean) {
  const flagsSettingParams: string[] = [];
  if (!Alertflag) {
    return flagsSettingParams;
  }
  if (useAlertSound) {
    flagsSettingParams.push("sound");
  }

  if (newMailsList !== ["--"]) {
    flagsSettingParams.push("mail");
  }

  // backGroundAlertFlagsは点灯の状態を保持するものの為、それを参照してDB格納データを作らないこと!
  // TODO: とりあえずデフォルトでオンにする。設定反映時に修正
  // if () {
  flagsSettingParams.push("flash");
  // }

  return flagsSettingParams;
}

function makeNewlampColorAndFlagMap(newSettingDataSet: newSettingDataSetType, useAlertSound: boolean, newMailsList: string[]) {

  const newlampColorAndFlagMap: newlampColorAndFlagMapType[] = [];
  let keyColor: string | string[] = "";

  // パトランプの色段分forで回す
  for (const key in newSettingDataSet.newkeyColors) {
    keyColor = "undefined";

    if (!newSettingDataSet.newkeyColors[key] || newSettingDataSet.newkeyColors[key] !== "undefined") {
      keyColor = newSettingDataSet.newkeyColors[key];
    }

    const Alertflag: boolean = newSettingDataSet.alertCheck[key];
    const flagsParams: string[] = makeFlagsSettingParams(useAlertSound, newMailsList, Alertflag);
    const mailsArray: string[] = Alertflag ? newMailsList : [];

    newlampColorAndFlagMap.push(
      {
        color: keyColor,
        flag: Alertflag,
        flags: flagsParams,
        mails: mailsArray
      }
    );

  }
  return newlampColorAndFlagMap;
}

export function makeSendSignallampSettingData(newSettingDataSet: newSettingDataSetType, useAlertSound: boolean) {
  let newMailsList: string[] = ["--"];
  if (newSettingDataSet.addMails) {
    newMailsList = newSettingDataSet.addMails.split(",");
  }

  const newlampColorAndFlagMap: newlampColorAndFlagMapType[] = makeNewlampColorAndFlagMap(newSettingDataSet, useAlertSound, newMailsList);

  const updateData: SignallampStoreType = {
    device_id: newSettingDataSet.addDeviceId,
    lamp_color_and_flag_map: newlampColorAndFlagMap,
    mails: newMailsList,
    mail_send_interval: newSettingDataSet.mailSendInterval,
    table_name: newSettingDataSet.addDbTable,
    location: newSettingDataSet.addLocation,
    user_id: newSettingDataSet.userID,
    auth_store_name: newSettingDataSet.authStoreName,
    sensor_data_send_check_flag: "false",
  };

  return updateData;
}
